"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var NON_CACHEABLE_TYPENAMES = Object.freeze([
    'lp_ReleaseFormat',
]);
function nonCacheable(typename) {
    return NON_CACHEABLE_TYPENAMES.indexOf(typename) > -1;
}
exports.cacheOptions = {
    fragmentMatcher: new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
        introspectionQueryResultData: {
            __schema: {
                types: [
                    {
                        kind: 'UNION',
                        name: 'HydratedFacet',
                        possibleTypes: [
                            {
                                name: 'Brand',
                            },
                            {
                                name: 'Category',
                            },
                        ],
                    },
                    {
                        kind: 'UNION',
                        name: 'FeedEntry',
                        possibleTypes: [
                            {
                                name: 'Article',
                            },
                            {
                                name: 'Listing',
                            },
                        ],
                    },
                ],
            },
        },
    }),
    dataIdFromObject: function (result) {
        if (result.__typename) {
            if (nonCacheable(result.__typename)) {
                return null;
            }
            if (result._id !== undefined) {
                return result.__typename + ":" + result._id;
            }
            if (result.uuid !== undefined) {
                return result.__typename + ":uuid:" + result.uuid;
            }
            if (result.id !== undefined) {
                return result.__typename + ":id:" + result.id;
            }
        }
        return null;
    },
};
//# sourceMappingURL=apollo_client.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/apollo_client.js
// module id = 6ZD8
// module chunks = 20 21